/** Mirrors public.has_admin_permission() after admin_permissions table drop (20260624120000). */

export type AdminRoleType =
  | "super_admin"
  | "operations_admin"
  | "read_only_admin";

const OPERATIONS_ADMIN_PERMISSIONS = [
  "manage_venues",
  "manage_deals",
  "manage_users",
  "manage_disputes",
  "manage_alerts",
  "view_venues",
  "view_deals",
  "view_users",
  "view_analytics",
  "view_disputes",
  "view_alerts",
] as const;

/** Full super_admin grant set (historical seeds + disputes/alerts). */
const SUPER_ADMIN_PERMISSIONS = [
  "manage_venues",
  "manage_deals",
  "manage_users",
  "manage_settings",
  "manage_invoices",
  "manage_commissions",
  "manage_consent",
  "manage_data_requests",
  "manage_disputes",
  "manage_alerts",
  "view_venues",
  "view_deals",
  "view_users",
  "view_analytics",
  "view_invoices",
  "view_commissions",
  "view_audit_logs",
  "view_consent",
  "view_data_requests",
  "view_disputes",
  "view_alerts",
] as const;

const READ_ONLY_ADMIN_PERMISSIONS = SUPER_ADMIN_PERMISSIONS.filter((p) =>
  p.startsWith("view_")
);

export function adminHasPermission(
  adminRole: AdminRoleType,
  permissionName: string
): boolean {
  if (adminRole === "super_admin") return true;
  if (adminRole === "operations_admin") {
    return (OPERATIONS_ADMIN_PERMISSIONS as readonly string[]).includes(
      permissionName
    );
  }
  return (
    adminRole === "read_only_admin" && permissionName.startsWith("view_")
  );
}

export function getAdminPermissionsForRole(
  adminRole: AdminRoleType
): string[] {
  switch (adminRole) {
    case "super_admin":
      return [...SUPER_ADMIN_PERMISSIONS];
    case "operations_admin":
      return [...OPERATIONS_ADMIN_PERMISSIONS];
    case "read_only_admin":
      return [...READ_ONLY_ADMIN_PERMISSIONS];
    default:
      return [];
  }
}
